import {
  Dialog,
  Button,
  Text,
  Stack,
  Column,
  Columns,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';

interface Props {
  id?: string;
  isOpen: boolean;
  cancelBtnText: string;
  confirmBtnText: string;
  children: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export const CtaDialog = ({
  id = 'cta-dialog',
  isOpen,
  cancelBtnText,
  confirmBtnText,
  children,
  onCancel,
  onConfirm,
  title,
}: Props) => (
  <Dialog id={id} title={title} open={isOpen} onClose={onCancel} width="xsmall">
    <Stack space="large">
      <Text>{children}</Text>
      <Columns space="small">
        <Column>
          <Button variant="ghost" onClick={onCancel}>
            {cancelBtnText}
          </Button>
        </Column>
        <Column>
          <Button onClick={onConfirm}>{confirmBtnText}</Button>
        </Column>
      </Columns>
    </Stack>
  </Dialog>
);
